module.exports = __webpack_public_path__ + "img/ic_head_hight_8.5457978f.png";